<template>

    <div class="box">
        <CustomTable
            id_table="payment_methods"
            :items="payment_method_formatted"
            :busy.sync="working"
            :rawColumns="['numero']"
            :externSlotColumns="extern_slot_columns"
            primaryKey="id"
        >
            <template v-slot:custom-slot-cell(mandate_action)="{ data }">
                <a v-if="data.mandate_action == 'create_mandate'" class='btn btn-secondary' @click.prevent='create_mandate(data.id)'>Créer un mandat</a>
                <a v-else-if="data.mandate_action == 'cancel_mandate'" class='btn btn-secondary' @click.prevent='cancel_mandate(data.mandate.id)'>Annuler un mandat</a>
                <a v-else class='btn btn-primary' :href="data.mandate_action">Valider le mandat</a>
            </template>

        </CustomTable>
    </div>
</template>


<script type="text/javascript">
    import Invoice from '@/mixins/Invoice.js'
    import Marketplace from '@/mixins/Marketplace.js'
    import Navigation from '@/mixins/Navigation.js'

	export default {
        name: "PaymentsMethodsList",
        mixins:[Marketplace, Invoice, Navigation],
		data () {
			return {
                working: false,
                processing: false,
                payment_method: null,
                extern_slot_columns: [
                    'mandate_action'
                ],


                events_tab: {
                    // "TableAction::addPaymentMethod": (params) => {
                    //     console.log("tetete");
                    //     // this.$router.push({ name: 'AddPaymentMethod' })
                    // }
                }
			}
		},

		mounted() {
            this.init_component()
		},

		methods: {
            async init_component() {
                this.working = true

                await this.loadPaymentMethod()
            },

            async checkForm(){
            },

            async loadPaymentMethod() {
                this.getPaymentMethod()
                .then(r => {
                    this.payment_method = r
                    this.working = false
                })
                .catch(e => {
                })
            },

            async create_mandate(bankaccount_id){
                this.working = true
                let result = await this.createMandate(bankaccount_id)
                if(result != null)
                {
                    this.init_component()
                }
            },

            async cancel_mandate(mandate_id){
                this.working = true
                let result = await this.cancelMandate(mandate_id)
                if(result != null)
                {
                    this.init_component()
                }
            }
        },
        
        computed: {
            payment_method_formatted(){
                let payments_methods = []

                if(this.payment_method != null)
                {
                    for (let i = 0; i < this.payment_method.length; i++)
                    {
                        let temp = this.payment_method[i]
                        if(temp.mandate == null)
                        {
                            temp.mandate_action = "create_mandate"
                        }
                        else if(temp.mandate.status == "SUBMITTED" || temp.mandate.status == "ACTIVE")
                        {
                            temp.mandate_action = "cancel_mandate"
                        }
                        else
                        {
                            temp.mandate_action = temp.mandate.redirect_url
                        }

                        payments_methods.push(temp)
                    }
                }

                return payments_methods
            }
        },

		components: {
            HeaderTab: () => import('GroomyRoot/components/HeaderTab'),
            CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
		}
	}
</script>
